import "@/App.css";
import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import Layout from "@/components/Layout";
import AuthPage from "@/pages/AuthPage";
import SubDashboard from "@/pages/SubDashboard";
import ProfilePage from "@/pages/ProfilePage";
import DocumentsPage from "@/pages/DocumentsPage";
import AdminDashboard from "@/pages/AdminDashboard";
import AdminCarriers from "@/pages/AdminCarriers";
import AdminCarrierDetail from "@/pages/AdminCarrierDetail";
import EmailLogPage from "@/pages/EmailLogPage";

function LoadingScreen() {
  return (
    <div className="flex min-h-screen items-center justify-center bg-navy" data-testid="loading-screen">
      <div className="flex flex-col items-center gap-3">
        <img src="/tagxpress-logo.png" alt="TAG Xpress logo" className="h-12 w-auto rounded-md bg-white px-3 py-2" />
        <div className="h-5 w-5 animate-spin rounded-full border-2 border-slate-500 border-t-brand" />
      </div>
    </div>
  );
}

function Protected({ children, role }) {
  const { user } = useAuth();
  if (user === null) return <LoadingScreen />;
  if (!user) return <Navigate to="/login" replace />;
  if (role && user.role !== role) return <Navigate to="/" replace />;
  return children;
}

function RoleRedirect() {
  const { user } = useAuth();
  if (user === null) return <LoadingScreen />;
  if (!user) return <Navigate to="/login" replace />;
  return <Navigate to={user.role === "admin" ? "/admin" : "/dashboard"} replace />;
}

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Toaster position="top-right" richColors />
        <Routes>
          <Route path="/login" element={<AuthPage />} />
          <Route path="/" element={<RoleRedirect />} />
          <Route element={<Protected><Layout /></Protected>}>
            <Route path="/dashboard" element={<Protected role="subcontractor"><SubDashboard /></Protected>} />
            <Route path="/profile" element={<Protected role="subcontractor"><ProfilePage /></Protected>} />
            <Route path="/documents" element={<Protected role="subcontractor"><DocumentsPage /></Protected>} />
            <Route path="/admin" element={<Protected role="admin"><AdminDashboard /></Protected>} />
            <Route path="/admin/carriers" element={<Protected role="admin"><AdminCarriers /></Protected>} />
            <Route path="/admin/carriers/:id" element={<Protected role="admin"><AdminCarrierDetail /></Protected>} />
            <Route path="/admin/emails" element={<Protected role="admin"><EmailLogPage /></Protected>} />
          </Route>
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
